import { render, staticRenderFns } from "./DrivingAppointmentDetails.vue?vue&type=template&id=ca8e949a"
import script from "./DrivingAppointmentDetails.vue?vue&type=script&lang=ts"
export * from "./DrivingAppointmentDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports